import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import Trombinoscope from 'components/trombinoscope/trombinoscope'
import "./trombiParcoursPro.scss"
import personnes from 'constants/personnes'
export default function TrombiParcoursPro() {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Trombinoscope de l'équipe",
            icon : "picto_trombinoscope.svg",
            color : "bckRed"
        })
    }, [])
    return (
        <div id="trombiParcoursPro" className='page'>
            <Trombinoscope personnes={personnes} />
        </div>
    )
}
